import React, { Component } from 'react';

import Events from 'libs/Events';
import PropTypes from 'prop-types';
import RadioList from 'components/forms/Radio';
import { injectModel } from 'state';
import styled from 'libs/styled';
import { withTranslation } from 'react-i18next';

const StyledRadioList = styled(RadioList)`
    label {
        display: flex;
        justify-content: space-between;

        p + p {
            flex-shrink: 0;
            margin-left: 24px;
        }
    }
`;

class ShippingFallback extends Component {
    static propTypes = {
        basket: PropTypes.object.isRequired,
        onLoad: PropTypes.func,
        t: PropTypes.func.isRequired,
    };

    static defaultProps = {
        onLoad: null,
    };

    state = {
        error: null,
        loading: false,
    };

    componentDidMount() {
        const { onLoad } = this.props;

        onLoad && onLoad();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { basket, onLoad } = this.props;

        // Rerender if the onLoad-function has changed
        if (nextProps.onLoad !== onLoad) {
            return true;
        }

        // Rerender if there are any new/removed shipping methods
        if (JSON.stringify(nextProps.basket.shippingMethods) !== JSON.stringify(basket.shippingMethods)) {
            return true;
        }

        // Rerender if the basket has a new shipping method set
        if (nextProps.basket.shippingMethodId !== basket.shippingMethodId) {
            return true;
        }

        // Rerender if this components state is updated
        if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
            return true;
        }

        return false;
    }

    render() {
        const {
            t,
            basket: { shippingMethods, shippingMethodId, selectShippingMethod },
        } = this.props;

        const { error, loading } = this.state;

        const nonIngrid = Object.keys(shippingMethods).filter(k => k.indexOf('ingrid') === -1);

        if (nonIngrid.length === 0) {
            console.error(`Found incorrect amount of non-ingrid shipping methods: ${nonIngrid.length}.`);
            return null;
        }

        const updateShippingMethod = async value => {
            // Make sure that the id is a possible value
            if (nonIngrid.indexOf(value.id) !== -1) {
                // Set loading to true and reset error messages
                this.setState({
                    error: null,
                    loading: true,
                });

                // Update the basket shipping method and wait for the response
                const response = await selectShippingMethod(value.id);

                // Set loading to false and add error message if something went wrong
                this.setState({
                    error: response.status !== 200 ? t('Something went wrong.') : null,
                    loading: false,
                });
            }
        };

        const radioItems = nonIngrid.map(item => ({
            id: shippingMethods[item].id,
            text: [shippingMethods[item].name, shippingMethods[item].price],
        }));

        return (
            <StyledRadioList
                defaultActive={shippingMethodId}
                items={radioItems}
                isLoading={loading}
                name="shippingMethod"
                error={error}
                handleChange={updateShippingMethod}
            />
        );
    }
}

export default withTranslation()(injectModel('basket')(ShippingFallback));
